import KMS from './KMS'
import SES from './SES'
import SQS from './SQS'
import SNS from './SNS'

export default {
  KMS,
  SES,
  SQS,
  SNS,
}
